import PropTypes from "prop-types";
import { ResponsiveContainer } from "recharts";
import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, Legend } from "recharts";

function StackedBarChart({
  data,
  keys,
  colors,
  xAxisKey = "channel__name",
  height = 400,
  width = "100%",
  stackId = "a",
}) {
  const keyNames = {
    all_view: "بازدید",
    all_like: "لایک",
    all_dislike: "دیسلایک",
    all_comments: "نظر",
    all_post: "تعداد ویدئو",
    all_save: "ذخیره",
    all_share: "اشتراک",
    countedLike: "لایک",
    countedDislike: "دیسلایک",
    countedSave: "ذخیره",
    countedShare: "اشتراک",
    countedView: "بازدید",
    subscribe_count: "اعضاء",
    repost_count: "بازنشر",
    all_rate: "امتیازات",
    senders_count: "ارسال کنندگان",
  };

  return (
    <ResponsiveContainer width={width} height={height}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xAxisKey} />
        <Tooltip />
        <Legend />
        {keys.map((key, index) => (
          <Bar
            key={key}
            dataKey={key}
            name={keyNames[key] || key} // You can map this to a more user-friendly name if needed
            stackId={stackId}
            fill={colors[index] || "#000"} // Default to black if a color is not provided
            isAnimationActive={false}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}

StackedBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  xAxisKey: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  stackId: PropTypes.string,
};

export default StackedBarChart;
